import { Card, Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useGetDashboardLoginsSummaryDetails } from "../hooks/useGetDashboardLoginsSummary";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useClientContext } from "../../../hooks/ClientContext";
import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { ThemedSpan } from "../../../components/utilities";

function DashboardLoginsDetails() {
    const { data, error, isLoading } = useGetDashboardLoginsSummaryDetails();
    const { id: masterAccountId } = useClientContext();
    const openMasterAccount = useOpenMasterAccount();

    if (isLoading) return (
        <Skeleton height={300} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data) {
        return null;
    }

    const mfaTypeMap = {
        0: "Pin",
        1: "App",
        2: "Google",
        3: "Unregistered",
        4: "Email Verification",
        5: "SMS Verification"
    };

    const handleOpenDashboardLogins = (e) => {
        e.preventDefault();
        openMasterAccount(masterAccountId, { suffix: "dashboard/logins" });
    };

    return (
        <>
            {data.results.map((item, i) => (
                <Col key={i} xs={12} sm={12} md={6} lg={4} xl={4}>
                    <Card style={{ height: "auto", minHeight: "300px" }}>
                        <Card.Body className="position-relative">
                            <Card.Title>
                                <Row>
                                    <Col className="col-sm-3 col-md-6" style={{ fontSize: "18px", paddingBottom: "20px" }}>
                                        <a className="text-reset text-decoration-none" href={`/client/${masterAccountId}/dashboard/logins`}
                                            onClick={(e) => handleOpenDashboardLogins(e)}>
                                            <ThemedSpan variant="primary" className="fw-bold">Dashboard Logins</ThemedSpan>
                                        </a>
                                    </Col>
                                    <Col className="col-sm-3 col-md-6 text-end">
                                        <div>
                                            {item.isOnline && (
                                                <OverlayTrigger
                                                    placement="left"
                                                    overlay={<Tooltip id={`tooltip-${item.id}`}>
                                                        <span>Logged In: {moment(item.createdDate).format('DD/MM/YYYY HH:mm')}</span>
                                                    </Tooltip>}>
                                                    <span className="badge rounded-pill bg-success p-2">Online</span>
                                                </OverlayTrigger>
                                            )}
                                            {!item.isOnline && (
                                                <OverlayTrigger
                                                    placement="left"
                                                    overlay={<Tooltip id={`tooltip-${item.id}`}>
                                                        <span>Last Logged In: {moment(item.createdDate).format('DD/MM/YYYY HH:mm')}</span>
                                                    </Tooltip>}>
                                                    <span className="badge rounded-pill bg-danger p-2">Offline</span>
                                                </OverlayTrigger>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Text as="div">
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Username:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        {item.username}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Email Address:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        {item.emailAddress}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Name:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        {item.forenames} {item.surname}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Active:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        <p>{item.isActive ? <ThemedSpan variant="success">Active</ThemedSpan> : <ThemedSpan variant="danger">Not Active</ThemedSpan>}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Locked:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        <p>{item.isLocked ? <ThemedSpan variant="danger">Locked</ThemedSpan> : <ThemedSpan variant="success">Unlocked</ThemedSpan>}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">MFA Enabled:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        <p>{item.isMfaEnabled ? mfaTypeMap[item.mfaType] : <ThemedSpan variant="danger">Not Set</ThemedSpan>}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6">
                                        <p><ThemedSpan variant="primary">Online:</ThemedSpan></p>
                                    </Col>
                                    <Col className="col-6">
                                        <p>{!item.isOnline 
                                            ? moment(item.createdDate).format('DD/MM/YYYY') 
                                            : (
                                                <OverlayTrigger
                                                    placement="left"
                                                    overlay={<Tooltip id={`tooltip-${item.id}`}>
                                                        <span>Logged In: {moment(item.createdDate).format('DD/MM/YYYY HH:mm')}</span>
                                                    </Tooltip>}>
                                                    <ThemedSpan variant="success">Online</ThemedSpan>
                                                </OverlayTrigger>
                                            )}
                                        </p>
                                    </Col>
                                </Row>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </>
    )
}

export default DashboardLoginsDetails;